var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 367.999V440C512 444.406 508.422 448 504 448S496 444.406 496 440V367.999C496 301.841 442.172 247.997 376 247.997H29.299L205.266 401.968C208.594 404.874 208.938 409.937 206.016 413.281C204.438 415.062 202.219 415.999 200 415.999C198.125 415.999 196.25 415.343 194.734 414.031L2.734 246.028C1 244.497 0 242.309 0 239.997C0 237.684 1 235.496 2.734 233.965L194.734 65.962C198.047 63.087 203.094 63.4 206.016 66.712C208.938 70.056 208.594 75.119 205.266 78.025L29.299 231.996H376C450.984 231.996 512 292.997 512 367.999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.3d918a23a00ef2a81d45ab1df20cad27.svg";
export { ForwardRef as ReactComponent };